import React from 'react';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Reframe } from './components/Reframe';
import { ProductPresentation } from './components/ProductPresentation';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { TargetAudience } from './components/TargetAudience';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { PurchaseSection } from './components/PurchaseSection';
import { Footer } from './components/Footer';
export function App() {
  // Initialize Meta Pixel
  return <div className="min-h-screen bg-brand-black font-sans text-brand-black selection:bg-brand-green selection:text-brand-black" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Reframe data-id="element-3" />
      <ProductPresentation data-id="element-4" />
      <Testimonials data-id="element-5" />
      <Bonuses data-id="element-6" />
      <ValueStack data-id="element-7" />
      <TargetAudience data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <PurchaseSection data-id="element-11" />
      <Footer data-id="element-12" />

      {/* Floating Elements */}
      <SocialProofPopup data-id="element-13" />
    </div>;
}